import * as React from "react";
import type { SVGProps } from "react";
const SvgUserCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke="url(#user-circle_svg__a)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={3.333}
      d="M16.5 27.998c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12s-12 5.372-12 12c0 6.627 5.373 12 12 12"
    />
    <path
      fill="url(#user-circle_svg__b)"
      fillRule="evenodd"
      d="M11.93 14.14c0 2.45 2.121 4.572 4.57 4.572s4.572-2.122 4.572-4.571v-1.143c0-2.45-2.122-4.572-4.572-4.572-2.449 0-4.57 2.122-4.57 4.572zm10.856 6.847c.892.354 1.714 1.252 1.714 2.296v2.285a.83.83 0 0 1-.586.796l-7.414 2.3-7.435-2.524a.83.83 0 0 1-.565-.79v-2.067c0-1.044.822-1.942 1.714-2.296 1.31-.521 3.355-1.132 6.287-1.132s4.974.61 6.285 1.132"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="user-circle_svg__a"
        x1={23.583}
        x2={17.1}
        y1={27.998}
        y2={8.544}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAEAB3" />
        <stop offset={0.339} stopColor="#FCB242" />
        <stop offset={0.889} stopColor="#FFE793" />
      </linearGradient>
      <linearGradient
        id="user-circle_svg__b"
        x1={21.637}
        x2={11.626}
        y1={11.995}
        y2={24.958}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAEAB3" />
        <stop offset={1} stopColor="#FCB242" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgUserCircle;
